import { tns } from 'tiny-slider/src/tiny-slider';

class Slider {
  constructor(container) {
    this.selectors = {
      items: '.c-slider__items',
      nav: '.c-slider__nav',
    };

    this.DOM = {
      container,
      items: container.querySelector(this.selectors.items),
      nav: container.querySelector(this.selectors.nav),
    };

    this.DOM.controls = this.getOption('sliderControls', false, a =>
      document.querySelector(a),
    );

    const config = {
      container: this.DOM.items,
      items: 1,
      slideBy: 'page',
      controls: !!this.DOM.controls,
      controlsContainer: this.DOM.controls,
      navContainer: this.DOM.nav,
      autoplay: this.getOption('sliderAutoplay', false),
      autoplayButtonOutput: false,
      autoplayHoverPause: true,
      lazyload: this.getOption('sliderLazyload', true),
      lazyloadSelector: 'img[data-src]',
      responsive: {
        1024: {
          items: this.getOption('sliderItems', 1, (a, b) =>
            Math.floor(Number.parseFloat(a, b)),
          ),
          slideBy: this.getOption('sliderSlideBy', 'page'),
          gutter: this.getOption('sliderGutter', false),
        },
        1280: {
          get edgePadding() {
            // this is options.responsive.1280 object, so we cannot use this.getOption
            if ('sliderEdgePadding' in container.dataset) {
              return container.dataset.sliderEdgePadding === 'full'
                ? (document.documentElement.clientWidth - 1180) / 2
                : Number.parseInt(container.dataset.sliderEdgePadding, 10);
            }
            return 0;
          },
          items: this.getOption('sliderItems', 1, Number.parseFloat),
        },
      },
    };
    this.slider = tns(config);

    if (config.responsive[1280].edgePadding) {
      this.timeout = null;
      window.addEventListener('orientationchange', this.onResize);
      window.addEventListener('resize', this.onResize);
    }
  }

  getOption = (name, defaultValue, extractor = Number.parseInt) =>
    name in this.DOM.container.dataset
      ? extractor(this.DOM.container.dataset[name], 10)
      : defaultValue;

  onResize = () => {
    clearTimeout(this.timeout);

    const mql = window.matchMedia('(min-width: 1280px)');
    if (mql.matches) {
      this.slider.destroy();
      this.slider = this.slider.rebuild();
    }
  };
}

export default () => {
  Array.from(document.querySelectorAll('.c-slider')).forEach(
    container => new Slider(container),
  );
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/goodie-wp-chisel/src/scripts/modules/slider.js